/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../api/DataItemAPI'
], (APIFactory, DataItemAPI) => {
	class QueryResultColumn {
		constructor(columnInfo) {
			this.columnInfo = columnInfo;
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [DataItemAPI]);
			}
			return this.api;
		}

		getId() {
			return this.columnInfo.u;
		}

		getLabel() {
			return this.columnInfo.d;
		}

		getColumnId() {
			return this.columnInfo.u;
		}

		getAggregation() {
			return this.columnInfo.aggregate;
		}

		getDataType() {
			throw 'getDataType is not implemented for QueryResultColumn';
		}

		isDateOrTimeType() {
			throw 'isDateOrTimeType is not implemented for QueryResultColumn';
		}

		// ColumnInfo is extracted from the itemClass of the query response. Only the fact (measure) type has an aggregate value in the itemClass.
		getType() {
			return this.columnInfo.aggregate ? 'fact' : 'attribute';
		}

		getNavigationPathId() {
			throw 'getNavigationPathId is not implemented for QueryResultColumn';
		}

		setNavigationPathId() {
			throw 'setNavigationPathId is not implemented for QueryResultColumn';
		}

		setAggregation() {
			throw 'setAggregation is not implemented for QueryResultColumn';
		}

		hasDefaultAggregation() {
			throw 'hasDefaultAggregation is not implemented for QueryResultColumn';
		}

		hasDefaultSort() {
			throw 'hasDefaultSort is not implemented for QueryResultColumn';
		}

		hasDefaultFormat() {
			throw 'hasDefaultFormat is not implemented for QueryResultColumn';
		}

		getMetadataColumn() {
			throw 'getMetadataColumn is not implemented for QueryResultColumn';
		}

		getFormat() {
			throw 'getFormat is not implemented for QueryResultColumn';
		}

		setFormat() {
			throw 'setFormat is not implemented for QueryResultColumn';
		}

		getSort() {
			throw 'getSort is not implemented for QueryResultColumn';
		}

		setSort() {
			throw 'setSort is not implemented for QueryResultColumn';
		}

		getTopBottom() {
			throw 'getTopBottom is not implemented for QueryResultColumn';
		}

		setTopBottom() {
			throw 'setTopBottom is not implemented for QueryResultColumn';
		}

		canDrillDown() {
			throw 'canDrillDown is not implemented for QueryResultColumn';
		}

		drillDown() {
			throw 'drillDown is not implemented for QueryResultColumn';
		}

		getDrillDownValue() {
			throw 'getDrillDownValue is not implemented for QueryResultColumn';
		}

		getIsolatedValue() {
			throw 'getIsolatedValue is not implemented for QueryResultColumn';
		}

		drillUp() {
			throw 'drillUp is not implemented for QueryResultColumn';
		}

		getDrillUpValue() {
			throw 'getDrillUpValue is not implemented for QueryResultColumn';
		}

		clearDrill() {
			throw 'clearDrill is not implemented for QueryResultColumn';
		}

		setBinning() {
			throw 'setBinning is not implemented for QueryResultColumn';
		}

		getBinning() {
			throw 'getBinning is not implemented for QueryResultColumn';
		}

		hasModelSort() {
			throw 'hasModelSort is not implemented for QueryResultColumn';
		}

		getUnion() {
			throw 'getUnion is not implemented for QueryResultColumn';
		}

		isColumnUnavailable() {
			throw 'isColumnUnavailable is not implemented for QueryResultColumn';
		}
	}

	return QueryResultColumn;
});
